export default __webpack_public_path__ + "static/media/calendar.e15d6712.svg";